module.exports = __webpack_public_path__ + "static/media/roundedshoulder_mild_left.2d4b3608.png";